export function propsToClasses(props, styles) {
  let key;
  let val;
  let classes = '';
  for (let prop in props) {
    val = props[prop];
    if (val) {
      if (typeof val === 'string') {
        key = `${prop}-${val}`;
      } else {
        key = prop;
      }
      if (key in styles) {
        classes && (classes += ' ');
        classes += styles[key];
      }
    }
  }
  return classes;
}